export default "__VITE_ASSET__DLZcEkvd__"